export default "__VITE_ASSET__BA6mi23N__"